import React, { useEffect, useMemo } from "react";
import { Grid } from "@mui/material";
import ModalProductoSeries from "@/shared/components/ui/CargarSeries/ModalProductoSeries";
import { useCargarSeriesProductos } from "@/store/erp/productos/useCargarSeriesProductos.store";
import {
  formatDateWithTimeAMPM, gridSizeMdLg4,
  ModulosMotivoENUM,
  newIngresoProductoSchema, ROUTER_PATHS,
  texto, useCheckPermissionsArray,
  useLoaders,
  useUploadFile
} from "@/shared";
import SampleTablePagination from "@/shared/components/ui/SampleTablePagination";
import { useTableColumnsInventarioSerie } from "@/shared/hooks/useTableColumnsInventarioSerie";
import {
  CustomTextField, CustomAutocomplete,
  SingleTableBoxScene,
  LoaderComponent
} from "@/shared/components/ui";
import {
  AlertSeverityEnum, IDtaUnidadTransporte,
  IngresoInventarioForm, MaterialTransferido
} from "@/shared/interfaces";
import { BODEGAS, Ubicaciones, UbicacionesParams } from "@/shared/interfaces/erp/inventario";
import { IDataMotivo } from "@/shared/interfaces/erp/inventario/motivo.interface";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { getBodegas, getUbicacionProductoSimple, useCreateIngresoProducto, useFetchMotivos } from "@/shared/actions/erp";
import { useFetchUnidadTransporte } from "@/shared/actions/erp/administration/unidad-transporte.actions";
import { useUiStore } from "@/store/ui";
import ModalProductoSelectComponente from "../shared/componente/ModalProductoSelectComponente";
import { useAuthStore } from "@/store/auth";
import { PermissionsEnum } from "@/auth/interfaces";
import CustomAutocompleteFetchForm from "@/shared/components/ui/CustomAutocompleteFetchForm";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import useAutocompleteFetch from "@/shared/hooks/useAutocompleteFetch";
import ModalReingresoSeries from "../shared/componente/ModalReingresoSeries";
import { toast } from "react-toastify";
import { useFetchPostReingresoSerie } from "@/shared/actions";
//const returnUrlIngresoInventarioHistorial = ""

const InventarioManual: React.FC = () => {

  useCheckPermissionsArray([
    PermissionsEnum.api_view_ingresoinventario,
    PermissionsEnum.api_change_ingresoinventario,
    PermissionsEnum.api_add_ingresoinventario
  ])
  const navigate = useNavigate()
  ///* form
  const form = useForm<IngresoInventarioForm>({
    resolver: yupResolver(newIngresoProductoSchema as any),

  });

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = form;

  ///* store
  const setAlert = useUiStore(s => s.setAlert);

  const productos = useCargarSeriesProductos(s => s.productos)
  const paginatedData = useCargarSeriesProductos(s => s.paginatedData)
  const setPagination = useCargarSeriesProductos(s => s.setPagination)
  const pagination = useCargarSeriesProductos(s => s.pagination)
  const handleAgregarProducto = useCargarSeriesProductos(s => s.handleAgregarProducto)
  const handleAgregarUrlSerie = useCargarSeriesProductos(s => s.handleAgregarUrlSerie)
  const { handleUploadFile } = useUploadFile();
  const clearSelectedItems = useCargarSeriesProductos(s => s.clearSelectedItems)
  const { columnsIngresoProducto } = useTableColumnsInventarioSerie();
  const user = useAuthStore(s => s.user)

  const setConfirmDialogIsOpen = useUiStore(s => s.setConfirmDialogIsOpen);
  const setConfirmDialog = useUiStore(s => s.setConfirmDialog);

  const setDataReingreso = useCargarSeriesProductos(s => s.setDataReingreso)
  const dataReingreso = useCargarSeriesProductos(s => s.dataReingreso)

  ///* react query
  /* const {
    data: ubOrigen, 
    isLoading: isLoaUbOrigen  
  } = useFetchUbicaciones({
    page_size: 600,
    bodega: form.getValues().bodega
  }, !!form.watch('bodega')); */

  const {
    mutateAsync: mutatePostReingresoSerie,
    isPending: isPendingReingreso
  } = useFetchPostReingresoSerie({
    returnUrl: ROUTER_PATHS.inventario.ingresoHistorial,
    navigate
  })

  const {
    data: dataUT,
    isLoading: isLoadingUT
  } = useFetchUnidadTransporte({ page_size: 100 });

  const {
    data: dataMotivos,
    isLoading: isLoadingMotivo
  } = useFetchMotivos({
    modulo: ModulosMotivoENUM.INGRESO_INVENTARIO
  });

  const { mutateAsync, isPending } = useCreateIngresoProducto();

  const {
    fetchAutocompleteUbicacion
  } = useAutocompleteFetch()

  const watchBodega = form.watch('bodega');
  const watchUbicacion = form.watch('ubicacion');


  const paramsUbicaciones = useMemo<UbicacionesParams>(() => (
    {
      bodega: watchBodega
    }
  ), [watchBodega])

  ///* funciones

  const onSubmit = async (e: IngresoInventarioForm) => {

    e.fecha_actual_fronted = dayjs().toISOString();

    if (productos.length === 0)
      return setAlert(true, 'Agregar inventariables', AlertSeverityEnum.info)

    for (let element of productos) {
      if (element.contiene_serie && element.series?.length == 0)
        return setAlert(true, `El producto con el código ${element.producto_data?.codigo} series pendientes por cargar`, AlertSeverityEnum.error);

      if (element.contiene_serie && element.series?.length != element.cantidad)
        return setAlert(true, `El producto con el código ${element.producto_data?.codigo} tiene una discrepancia entre la cantidad ingresada y las series cargadas. Por favor, revisa la información y vuelve a intentarlo.`, AlertSeverityEnum.error);
    }

    setConfirmDialogIsOpen(true);

    setConfirmDialog({
      isOpen: true,
      title: '¡Confirmar!',
      subtitle:
        'Confirmar que deseas proceder con el ingreso de inventario. Esta acción es irreversible. ¿Estás seguro de continuar?',
      onClose() {
        setConfirmDialogIsOpen(false);

      },
      async onConfirm() {
        setConfirmDialogIsOpen(false);


        const newProductoData = await handleAgregarUrlSerie(handleUploadFile);

        e.solicitud_ingreso = null;
        e.user = user?.username;
        e.productos = newProductoData ?? [];
        e.observaciones = {
          observacion_1: form.getValues().observacion_1
        }

        const resp = await mutateAsync(e);

        if (resp.code === 200 || resp.code === 202) {
          reset({ observacion_1: '' })
          clearSelectedItems();
          navigate(ROUTER_PATHS.inventario.ingresoHistorial)
          //clearSelectedItems(MaterialesKey.ingresoProductos);
        }


        //setIsGlobalLoading(false);

      },
      cancelTextBtn: 'Cerrar',
    });

    /*  */

  }

   const handleSendReingreso = async () => {
  
    
   try {

    if(!form.getValues().bodega || !form.getValues().ubicacion){
      toast.info('Debe seleccionar una bodega y una ubicación');
      return
    }

    if(!form.getValues().observacion_emisor || !form.getValues().motivo_emisor){
      toast.info('Debe seleccionar un motivo y ingresar una observación');
      return
    }

    if(!dataReingreso){
      toast.info('No hay series para reingresar');
      return
    }

    // relacion con el microservicio  MS-CONTABILIDAD (referencia_serie) = EVA (id_series)
    const ms_payload = dataReingreso.series_reingreso.map((element: any) => ({
      referencia_serie: element.id_series,
      serie_data: {
        referencia_serie: element.id_series,
        serie: element.serie
      },
      referencia_producto: dataReingreso.referencia_producto,
      user: user?.username || null,
      motivo_emisor: form.getValues().motivo_emisor || null,
      observacion_emisor: form.getValues().observacion_emisor || null,
      referencia_bodega: form.getValues().bodega || null,
      referencia_ubicacion: form.getValues().ubicacion || null,
      nombre_ubicacion: form.getValues().ubicacion_nombre || null,
      nombre_bodega: form.getValues().bodega_nombre || null,
      nombre_producto: dataReingreso.nombre_producto || null

    }))

    const res = await mutatePostReingresoSerie(ms_payload as any)

    if(res.code === 200 || res.code === 201){
      toast.success('Solicitud de reingreso enviada correctamente');
      setDataReingreso(null);
    }
    

   } catch (error) {
    
   } finally{
    //setDataReingreso(null)
   }
    
    
  }

  useEffect(() => {
    return () => {
      reset();
      clearSelectedItems();
    }
  }, [])

  const {
    fetchAutocompleteBodega
  } = useAutocompleteFetch()


  useLoaders(
    isPendingReingreso ||
    isPending
  )

  //if (isPending) return <LoaderComponent />

  return (
    <>
      <SingleTableBoxScene
        title="📦Ingreso de Inventarios"
        visibleReport={false}
        enableRedirect={true}
        enableCreateOrEditBtn={true}
        iconRedirect={<KeyboardArrowLeftIcon />}
        //urlRedirect={ROUTER_PATHS.inventario.ingresoHistorial}
        //textRedirect="Historial"
        urlRedirect={ROUTER_PATHS.inventario.ingresoHistorial}
        textRedirect="Regresar"
        fnCreateOrEdit={handleSubmit(onSubmit, () => {
          setAlert(true, 'Campos Incompletos', 'error');
        })}
      >

        <Grid container spacing={3} justifyContent={'start'}>
          <CustomTextField
            disabled={true}
            control={control}
            name="fecha_documento"
            defaultValue={formatDateWithTimeAMPM(new Date) || ''}
            size={gridSizeMdLg4}
            label={texto.fecha_documento}
            error={undefined}
            helperText={undefined} />

          <CustomAutocompleteFetchForm<BODEGAS, any, string>
            control={control}
            size={gridSizeMdLg4}
            name="bodega"
            label={texto.bodega}
            fetchData={fetchAutocompleteBodega}
            getOptionLabel={(opt) => opt.nombre || ''}
            key={'autocomplete-bodega'}
            getOptionKey={(o) => o.codigo!}
            onChangeRawValue={(e) => {
              reset({
                bodega: e?.codigo || '',
                ubicacion: '',
                bodega_nombre: e?.nombre || '',
              })
            }}
            loadOptionByValue={async (cod) => {
              const resp = await getBodegas({
                codigo: cod
              });
              return resp.data.data[0] ?? null
            }}
          />

          <CustomAutocompleteFetchForm<Ubicaciones>
            disabled={!watchBodega}
            control={control}
            size={gridSizeMdLg4}
            name="ubicacion"
            label="Ubicación"
            fetchParams={paramsUbicaciones}
            fetchData={fetchAutocompleteUbicacion}
            getOptionLabel={(opt) => opt.nombre || ''}
            key={'autocomplete-ubicacion'}
            getOptionKey={(o) => o.codigo!}
            onChangeRawValue={(e) => {
              if(e){
                form.setValue('ubicacion', e?.codigo || '');
                form.setValue('ubicacion_nombre', e?.nombre || '');
              }
            }}
          />


          <CustomAutocomplete<IDataMotivo>
            size={gridSizeMdLg4}
            label={texto.motivo}
            name="motivo"
            options={dataMotivos?.data.data || []}
            valueKey="nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().motivo || ''}
            isLoadingData={isLoadingMotivo}
            control={control}
            error={errors.motivo}
            helperText={errors.motivo?.message}
          />

          <CustomAutocomplete<IDtaUnidadTransporte>
            size={gridSizeMdLg4}
            label={texto.unidad_transporte}
            name="unidad_transporte"
            options={dataUT?.data.data || []}
            valueKey="chofer_nombre"
            actualValueKey="codigo"
            defaultValue={form.getValues().unidad_transporte || ''}
            isLoadingData={isLoadingUT}
            control={control}
            error={errors.unidad_transporte}
            helperText={errors.unidad_transporte?.message}
          />

          <CustomTextField
            size={gridSizeMdLg4}
            required={false}
            control={control}
            name="observacion_1"
            defaultValue={form.getValues().observacion_1 ?? ''}
            label={texto.observacion}
            error={errors.observacion_1}
            helperText={errors.observacion_1?.message} />


          {
            watchUbicacion && (
              <Grid item xs={12} textAlign={'end'}>
                <ModalProductoSelectComponente
                  onChange={async (e) => {

                    console.log(e);

                    const resp = await getUbicacionProductoSimple({
                      bodega: watchBodega,
                      ubicacion: watchUbicacion,
                      producto: e.codigo
                    })

                    const nuevoProducto: MaterialTransferido = {
                      id: e.id_producto,
                      codigo: e.codigo,
                      cantidad: "1",
                      series: [],
                      contiene_serie: e.contiene_serie,
                      usa_metros: e.usa_metros,
                      producto_data: {
                        codigo: e.codigo,
                        usa_metros: e.usa_metros,
                        metros_base: e.metros_base,
                        unidad_medida: e.unidad_medida,
                        categoria_producto: e.categoria_producto_data != null ? e.categoria_producto_data.nombre : "—",
                        subcategoria_producto: e.subcategoria_producto_data != null ? e.subcategoria_producto_data?.nombre : "—",
                        descripcion: e.descripcion ?? '—',
                        //stock_actual: e.stock_actual ?? '0',
                        stock_actual: resp.data.count != 0
                          ? resp.data.data[0].stock
                          : 0
                      },
                    };

                    handleAgregarProducto(nuevoProducto);
                  }}
                />

              </Grid>
            )
          }


          <Grid item xs={12}>

            <SampleTablePagination
              columns={columnsIngresoProducto}
              data={paginatedData}
              rowCount={productos.length}
              setPagination={setPagination}
              pagination={pagination}
              rowNumber={true}
            />

          </Grid>

        </Grid>
      </SingleTableBoxScene>


      <ModalProductoSeries
        generarSerie={true}
        seleccionarAutomatico={false}
        seleccionarManual={true}
        size={gridSizeMdLg4}
      />


      {
        dataReingreso && dataReingreso.tipo_error === 'REINGRESO' && (
          <ModalReingresoSeries
            form={form}
            open={dataReingreso.openModal}
            onClose={() => {
              setDataReingreso(null);
            }}
            onConfirm={handleSendReingreso}
          />
        )
      }

    </>
  );
};


export default InventarioManual;
